export default {
  metaTitle: 'Batch import product',
  pageTitle: 'Batch import product with Excel',
  description1: 'Maximum import 10,000 rows of product',
  description2: 'Please input the product data according to the sample template.',
  description3: 'Click here to download the Excel template file',
  downloadExcel: 'Download Excel Template',
  description4: 'Place the product data in the sheet named items in the template',
  description5: 'Please ensure the category you put in the sheet is the last level sub-category.',
  region: 'Region',
  warehouse: 'warehouse',
  storeCategory: 'storeCategory',
  shelf: 'Put on shelf or not',
  saveShelf: 'Save and put on shelf',
  saveWarehouse: 'saveWarehouse',
  uploadSuccess: '已成功上传',
  importData: 'Import Data',
  wrongFormat: '文件格式不正确',
  file: '文件',
  format_xls_xlsx: '格式不正确，请上传.xls,.xlsx文件。',
  waiting: '请等待后台数据处理完成，您无须停留在此页面！',
  retry: '尚有批量导入任务Processing，请稍候再试！',
  maximum_1000: '单次导入数据最大行数为10000！',
  fillInCorrectly: '请正确填写表格信息',
  selectWarehouseCategory: 'Please select warehouse and store category'
}
